import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
	${({ $variant }) =>
		$variant === 'home'
			? css`
					height: inherit;
					grid-row: 1;
					grid-column: 1;
					z-index: -1;

					.gatsby-image-wrapper {
						position: initial;
						height: inherit;
					}
				`
			: css`
					position: fixed;
					inset: 0;
					z-index: -1;
					width: 100vw;
					height: 100dvh;
					overflow: hidden;

					.gatsby-image-wrapper {
						height: inherit;
					}

					.overlay {
						position: absolute;
						inset: 0;
						background: rgb(0 0 0 / 88%);
					}
				`}
`;
